import React from "react";
import { runtimeEnvironment } from "../lib/runtimeEnvironment";

const StagingBanner: React.FC = () => {
  if (runtimeEnvironment.environment !== "staging") return null;

  return (
    <div
      role="status"
      aria-label="Staging release identity"
      data-testid="staging-banner"
      style={{
        position: "fixed",
        inset: "0 0 auto 0",
        zIndex: 2147483647,
        background: "#f59e0b",
        color: "#1f1300",
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        fontSize: "12px",
        fontWeight: 800,
        lineHeight: "24px",
        minHeight: "24px",
        padding: "0 12px",
        textAlign: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.35)",
      }}
    >
      STAGING · {runtimeEnvironment.gitSha}
    </div>
  );
};

export default StagingBanner;
